import { GoogleSpreadsheet } from "google-spreadsheet";

const dong = [
  "관산동",
  "성석동",
  "식사동",
  "풍동",
  "가좌동",
  "광명동",
  "사우동",
  "호평동",
  "괴안동",
  "도당동",
  "소사본동",
  "심곡동",
  "심곡본동",
  "약대동",
  "여월동",
  "원미동",
  "원종동",
  "춘의동",
  "세류동",
  "인계동",
  "관양동",
  "비산동",
  "석수동",
  "안양동",
  "죽전동",
  "김량장동",
  "삼동",
  "금오동",
  "녹양동",
  "신곡동",
  "의정부동",
  "호원동",
  "천호동",
  "미아동",
  "번동",
  "수유동",
  "공항동",
  "등촌동",
  "방화동",
  "염창동",
  "화곡동",
  "봉천동",
  "신림동",
  "개봉동",
  "고척동",
  "신도림동",
  "오류동",
  "가산동",
  "독산동",
  "시흥동",
  "도봉동",
  "창동",
  "장안동",
  "휘경동",
  "대방동",
  "사당동",
  "상도동",
  "서교동",
  "성산동",
  "신수동",
  "남가좌동",
  "연희동",
  "홍은동",
  "서초동",
  "마장동",
  "석관동",
  "하월곡동",
  "문정동",
  "목동",
  "신월동",
  "신정동",
  "갈현동",
  "구산동",
  "불광동",
  "역촌동",
  "응암동",
  "숭인동",
  "망우동",
  "상봉동",
  "중화동",
  "계산동",
  "귤현동",
  "간석동",
  "숭의동",
  "주안동",
  "부평동",
];

// 날짜
const hDate = [
  "2012-02",
  "2012-03",
  "2012-04",
  "2012-05",
  "2012-06",
  "2012-07",
  "2012-08",
  "2012-09",
  "2012-10",
  "2012-11",
  "2012-12",
  "2013-01",
  "2013-02",
  "2013-03",
  "2013-04",
  "2013-05",
  "2013-06",
  "2013-07",
  "2013-08",
  "2013-09",
  "2013-10",
  "2013-11",
  "2013-12",
  "2014-01",
  "2014-02",
  "2014-03",
  "2014-04",
  "2014-05",
  "2014-06",
  "2014-07",
  "2014-08",
  "2014-09",
  "2014-10",
  "2014-11",
  "2014-12",
  "2015-01",
  "2015-02",
  "2015-03",
  "2015-04",
  "2015-05",
  "2015-06",
  "2015-07",
  "2015-08",
  "2015-09",
  "2015-10",
  "2015-11",
  "2015-12",
  "2016-01",
  "2016-02",
  "2016-03",
  "2016-04",
  "2016-05",
  "2016-06",
  "2016-07",
  "2016-08",
  "2016-09",
  "2016-10",
  "2016-11",
  "2016-12",
  "2017-01",
  "2017-02",
  "2017-03",
  "2017-04",
  "2017-05",
  "2017-06",
  "2017-07",
  "2017-08",
  "2017-09",
  "2017-10",
  "2017-11",
  "2017-12",
  "2018-01",
  "2018-02",
  "2018-03",
  "2018-04",
  "2018-05",
  "2018-06",
  "2018-07",
  "2018-08",
  "2018-09",
  "2018-10",
  "2018-11",
  "2018-12",
  "2019-01",
  "2019-02",
  "2019-03",
  "2019-04",
  "2019-05",
  "2019-06",
  "2019-07",
  "2019-08",
  "2019-09",
  "2019-10",
  "2019-11",
  "2019-12",
  "2020-01",
  "2020-02",
  "2020-03",
  "2020-04",
  "2020-05",
  "2020-06",
  "2020-07",
  "2020-08",
  "2020-09",
  "2020-10",
  "2020-11",
  "2020-12",
  "2021-01",
  "2021-02",
  "2021-03",
  "2021-04",
  "2021-05",
  "2021-06",
  "2021-07",
];
// 전체보유그래프 데이터
const total = [
  {
    name: "고양시 덕양구",
    세대기준: 2,
    빌라기준: 2,
  },
  {
    name: "고양시 일산동구",
    세대기준: 13,
    빌라기준: 8,
  },
  {
    name: "고양시 일산서구",
    세대기준: 2,
    빌라기준: 1,
  },
  {
    name: "광명시",
    세대기준: 2,
    빌라기준: 1,
  },
  {
    name: "김포시",
    세대기준: 1,
    빌라기준: 1,
  },
  {
    name: "남양주시",
    세대기준: 6,
    빌라기준: 3,
  },
  {
    name: "부천시",
    세대기준: 52,
    빌라기준: 22,
  },
  {
    name: "수원시 권선구",
    세대기준: 8,
    빌라기준: 1,
  },
  {
    name: "수원시 팔달구",
    세대기준: 1,
    빌라기준: 1,
  },
  {
    name: "안양시 동안구",
    세대기준: 2,
    빌라기준: 2,
  },
  {
    name: "안양시 만안구",
    세대기준: 17,
    빌라기준: 8,
  },
  {
    name: "용인시 수지구",
    세대기준: 1,
    빌라기준: 1,
  },
  {
    name: "용인시 처인구",
    세대기준: 3,
    빌라기준: 1,
  },
  {
    name: "의왕시",
    세대기준: 3,
    빌라기준: 2,
  },
  {
    name: "의정부시",
    세대기준: 7,
    빌라기준: 5,
  },
  {
    name: "강동구",
    세대기준: 6,
    빌라기준: 3,
  },
  {
    name: "강북구",
    세대기준: 32,
    빌라기준: 11,
  },
  {
    name: "강서구",
    세대기준: 114,
    빌라기준: 51,
  },
  {
    name: "관악구",
    세대기준: 49,
    빌라기준: 20,
  },
  {
    name: "구로구",
    세대기준: 46,
    빌라기준: 18,
  },
  {
    name: "금천구",
    세대기준: 102,
    빌라기준: 31,
  },
  {
    name: "도봉구",
    세대기준: 6,
    빌라기준: 3,
  },
  {
    name: "동대문구",
    세대기준: 12,
    빌라기준: 5,
  },
  {
    name: "동작구",
    세대기준: 26,
    빌라기준: 14,
  },
  {
    name: "마포구",
    세대기준: 9,
    빌라기준: 4,
  },
  {
    name: "서대문구",
    세대기준: 9,
    빌라기준: 7,
  },
  {
    name: "서초구",
    세대기준: 1,
    빌라기준: 1,
  },
  {
    name: "성동구",
    세대기준: 1,
    빌라기준: 1,
  },
  {
    name: "성북구",
    세대기준: 2,
    빌라기준: 2,
  },
  {
    name: "송파구",
    세대기준: 2,
    빌라기준: 1,
  },
  {
    name: "양천구",
    세대기준: 46,
    빌라기준: 21,
  },
  {
    name: "은평구",
    세대기준: 19,
    빌라기준: 9,
  },
  {
    name: "종로구",
    세대기준: 5,
    빌라기준: 2,
  },
  {
    name: "중랑구",
    세대기준: 9,
    빌라기준: 3,
  },
  {
    name: "계양구",
    세대기준: 2,
    빌라기준: 2,
  },
  {
    name: "남동구",
    세대기준: 8,
    빌라기준: 1,
  },
  {
    name: "미추홀구",
    세대기준: 26,
    빌라기준: 10,
  },
  {
    name: "부평구",
    세대기준: 1,
    빌라기준: 1,
  },
];
// 매입시점그래프 라인차트 데이터
const 매입시점전체데이터 = [
  {
    date: "2012-02",
    매입: 1,
  },
  {
    date: "2012-03",
    매입: 1,
  },
  {
    date: "2012-04",
    매입: 1,
  },
  {
    date: "2012-05",
    매입: 1,
  },
  {
    date: "2012-06",
    매입: 1,
  },
  {
    date: "2012-07",
    매입: 1,
  },
  {
    date: "2012-08",
    매입: 1,
  },
  {
    date: "2012-09",
    매입: 1,
  },
  {
    date: "2012-10",
    매입: 1,
  },
  {
    date: "2012-11",
    매입: 1,
  },
  {
    date: "2012-12",
    매입: 1,
  },
  {
    date: "2013-01",
    매입: 1,
  },
  {
    date: "2013-02",
    매입: 1,
  },
  {
    date: "2013-03",
    매입: 1,
  },
  {
    date: "2013-04",
    매입: 2,
  },
  {
    date: "2013-05",
    매입: 2,
  },
  {
    date: "2013-06",
    매입: 2,
  },
  {
    date: "2013-07",
    매입: 2,
  },
  {
    date: "2013-08",
    매입: 2,
  },
  {
    date: "2013-09",
    매입: 2,
  },
  {
    date: "2013-10",
    매입: 2,
  },
  {
    date: "2013-11",
    매입: 2,
  },
  {
    date: "2013-12",
    매입: 2,
  },
  {
    date: "2014-01",
    매입: 2,
  },
  {
    date: "2014-02",
    매입: 2,
  },
  {
    date: "2014-03",
    매입: 2,
  },
  {
    date: "2014-04",
    매입: 2,
  },
  {
    date: "2014-05",
    매입: 2,
  },
  {
    date: "2014-06",
    매입: 2,
  },
  {
    date: "2014-07",
    매입: 2,
  },
  {
    date: "2014-08",
    매입: 2,
  },
  {
    date: "2014-09",
    매입: 2,
  },
  {
    date: "2014-10",
    매입: 2,
  },
  {
    date: "2014-11",
    매입: 2,
  },
  {
    date: "2014-12",
    매입: 2,
  },
  {
    date: "2015-01",
    매입: 2,
  },
  {
    date: "2015-02",
    매입: 2,
  },
  {
    date: "2015-03",
    매입: 2,
  },
  {
    date: "2015-04",
    매입: 2,
  },
  {
    date: "2015-05",
    매입: 3,
  },
  {
    date: "2015-06",
    매입: 3,
  },
  {
    date: "2015-07",
    매입: 5,
  },
  {
    date: "2015-08",
    매입: 5,
  },
  {
    date: "2015-09",
    매입: 7,
  },
  {
    date: "2015-10",
    매입: 11,
  },
  {
    date: "2015-11",
    매입: 12,
  },
  {
    date: "2015-12",
    매입: 22,
  },
  {
    date: "2016-01",
    매입: 39,
  },
  {
    date: "2016-02",
    매입: 49,
  },
  {
    date: "2016-03",
    매입: 75,
  },
  {
    date: "2016-04",
    매입: 84,
  },
  {
    date: "2016-05",
    매입: 121,
  },
  {
    date: "2016-06",
    매입: 165,
  },
  {
    date: "2016-07",
    매입: 183,
  },
  {
    date: "2016-08",
    매입: 212,
  },
  {
    date: "2016-09",
    매입: 239,
  },
  {
    date: "2016-10",
    매입: 272,
  },
  {
    date: "2016-11",
    매입: 290,
  },
  {
    date: "2016-12",
    매입: 307,
  },
  {
    date: "2017-01",
    매입: 367,
  },
  {
    date: "2017-02",
    매입: 391,
  },
  {
    date: "2017-03",
    매입: 436,
  },
  {
    date: "2017-04",
    매입: 464,
  },
  {
    date: "2017-05",
    매입: 483,
  },
  {
    date: "2017-06",
    매입: 498,
  },
  {
    date: "2017-07",
    매입: 528,
  },
  {
    date: "2017-08",
    매입: 532,
  },
  {
    date: "2017-09",
    매입: 538,
  },
  {
    date: "2017-10",
    매입: 541,
  },
  {
    date: "2017-11",
    매입: 550,
  },
  {
    date: "2017-12",
    매입: 551,
  },
  {
    date: "2018-01",
    매입: 551,
  },
  {
    date: "2018-02",
    매입: 553,
  },
  {
    date: "2018-03",
    매입: 553,
  },
  {
    date: "2018-04",
    매입: 553,
  },
  {
    date: "2018-05",
    매입: 556,
  },
  {
    date: "2018-06",
    매입: 557,
  },
  {
    date: "2018-07",
    매입: 558,
  },
  {
    date: "2018-08",
    매입: 560,
  },
  {
    date: "2018-09",
    매입: 573,
  },
  {
    date: "2018-10",
    매입: 573,
  },
  {
    date: "2018-11",
    매입: 574,
  },
  {
    date: "2018-12",
    매입: 574,
  },
  {
    date: "2019-01",
    매입: 574,
  },
  {
    date: "2019-02",
    매입: 574,
  },
  {
    date: "2019-03",
    매입: 574,
  },
  {
    date: "2019-04",
    매입: 574,
  },
  {
    date: "2019-05",
    매입: 575,
  },
  {
    date: "2019-06",
    매입: 575,
  },
  {
    date: "2019-07",
    매입: 575,
  },
  {
    date: "2019-08",
    매입: 575,
  },
  {
    date: "2019-09",
    매입: 575,
  },
  {
    date: "2019-10",
    매입: 575,
  },
  {
    date: "2019-11",
    매입: 576,
  },
  {
    date: "2019-12",
    매입: 576,
  },
  {
    date: "2020-01",
    매입: 576,
  },
  {
    date: "2020-02",
    매입: 581,
  },
  {
    date: "2020-03",
    매입: 581,
  },
  {
    date: "2020-04",
    매입: 581,
  },
  {
    date: "2020-05",
    매입: 581,
  },
  {
    date: "2020-06",
    매입: 581,
  },
  {
    date: "2020-07",
    매입: 582,
  },
  {
    date: "2020-08",
    매입: 582,
  },
  {
    date: "2020-09",
    매입: 582,
  },
  {
    date: "2020-10",
    매입: 582,
  },
  {
    date: "2020-11",
    매입: 582,
  },
  {
    date: "2020-12",
    매입: 582,
  },
  {
    date: "2021-01",
    매입: 582,
  },
  {
    date: "2021-02",
    매입: 582,
  },
  {
    date: "2021-03",
    매입: 582,
  },
  {
    date: "2021-04",
    매입: 582,
  },
  {
    date: "2021-05",
    매입: 582,
  },
  {
    date: "2021-06",
    매입: 582,
  },
  {
    date: "2021-07",
    매입: 582,
  },
];

// 상태현황전체데이터
const 상태현황전체데이터 = [
  {
    date: "2012-02",
    "압류.가압류": 0,
    소유: 1,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2012-03",
    "압류.가압류": 0,
    소유: 1,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2012-04",
    "압류.가압류": 0,
    소유: 1,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2012-05",
    "압류.가압류": 0,
    소유: 1,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2012-06",
    "압류.가압류": 0,
    소유: 1,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2012-07",
    "압류.가압류": 0,
    소유: 1,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2012-08",
    "압류.가압류": 0,
    소유: 1,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2012-09",
    "압류.가압류": 0,
    소유: 1,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2012-10",
    "압류.가압류": 0,
    소유: 1,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2012-11",
    "압류.가압류": 0,
    소유: 1,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2012-12",
    "압류.가압류": 0,
    소유: 1,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2013-01",
    "압류.가압류": 0,
    소유: 1,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2013-02",
    "압류.가압류": 0,
    소유: 1,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2013-03",
    "압류.가압류": 0,
    소유: 1,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2013-04",
    "압류.가압류": 0,
    소유: 2,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2013-05",
    "압류.가압류": 0,
    소유: 2,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2013-06",
    "압류.가압류": 0,
    소유: 2,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2013-07",
    "압류.가압류": 0,
    소유: 2,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2013-08",
    "압류.가압류": 0,
    소유: 2,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2013-09",
    "압류.가압류": 0,
    소유: 2,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2013-10",
    "압류.가압류": 0,
    소유: 2,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2013-11",
    "압류.가압류": 0,
    소유: 2,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2013-12",
    "압류.가압류": 0,
    소유: 2,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2014-01",
    "압류.가압류": 0,
    소유: 2,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2014-02",
    "압류.가압류": 0,
    소유: 2,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2014-03",
    "압류.가압류": 0,
    소유: 2,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2014-04",
    "압류.가압류": 0,
    소유: 2,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2014-05",
    "압류.가압류": 0,
    소유: 2,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2014-06",
    "압류.가압류": 0,
    소유: 2,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2014-07",
    "압류.가압류": 0,
    소유: 2,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2014-08",
    "압류.가압류": 0,
    소유: 2,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2014-09",
    "압류.가압류": 0,
    소유: 2,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2014-10",
    "압류.가압류": 0,
    소유: 2,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2014-11",
    "압류.가압류": 0,
    소유: 2,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2014-12",
    "압류.가압류": 0,
    소유: 2,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2015-01",
    "압류.가압류": 0,
    소유: 2,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2015-02",
    "압류.가압류": 0,
    소유: 2,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2015-03",
    "압류.가압류": 0,
    소유: 2,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2015-04",
    "압류.가압류": 0,
    소유: 2,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2015-05",
    "압류.가압류": 0,
    소유: 3,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2015-06",
    "압류.가압류": 0,
    소유: 3,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2015-07",
    "압류.가압류": 0,
    소유: 5,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2015-08",
    "압류.가압류": 0,
    소유: 5,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2015-09",
    "압류.가압류": 0,
    소유: 7,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2015-10",
    "압류.가압류": 0,
    소유: 11,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2015-11",
    "압류.가압류": 0,
    소유: 12,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2015-12",
    "압류.가압류": 0,
    소유: 22,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2016-01",
    "압류.가압류": 0,
    소유: 39,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2016-02",
    "압류.가압류": 0,
    소유: 49,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2016-03",
    "압류.가압류": 0,
    소유: 75,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2016-04",
    "압류.가압류": 0,
    소유: 84,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2016-05",
    "압류.가압류": 0,
    소유: 121,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2016-06",
    "압류.가압류": 0,
    소유: 165,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2016-07",
    "압류.가압류": 0,
    소유: 183,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2016-08",
    "압류.가압류": 0,
    소유: 212,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2016-09",
    "압류.가압류": 0,
    소유: 239,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2016-10",
    "압류.가압류": 0,
    소유: 272,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2016-11",
    "압류.가압류": 0,
    소유: 290,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2016-12",
    "압류.가압류": 0,
    소유: 307,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2017-01",
    "압류.가압류": 0,
    소유: 367,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2017-02",
    "압류.가압류": 0,
    소유: 391,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2017-03",
    "압류.가압류": 0,
    소유: 436,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2017-04",
    "압류.가압류": 0,
    소유: 464,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2017-05",
    "압류.가압류": 0,
    소유: 483,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2017-06",
    "압류.가압류": 0,
    소유: 498,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2017-07",
    "압류.가압류": 0,
    소유: 528,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2017-08",
    "압류.가압류": 0,
    소유: 532,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2017-09",
    "압류.가압류": 0,
    소유: 538,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2017-10",
    "압류.가압류": 0,
    소유: 541,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2017-11",
    "압류.가압류": 0,
    소유: 550,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2017-12",
    "압류.가압류": 1,
    소유: 550,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2018-01",
    "압류.가압류": 1,
    소유: 550,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2018-02",
    "압류.가압류": 1,
    소유: 552,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2018-03",
    "압류.가압류": 1,
    소유: 552,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2018-04",
    "압류.가압류": 1,
    소유: 552,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2018-05",
    "압류.가압류": 2,
    소유: 554,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2018-06",
    "압류.가압류": 2,
    소유: 555,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2018-07",
    "압류.가압류": 3,
    소유: 555,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2018-08",
    "압류.가압류": 3,
    소유: 557,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2018-09",
    "압류.가압류": 3,
    소유: 570,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2018-10",
    "압류.가압류": 3,
    소유: 570,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2018-11",
    "압류.가압류": 3,
    소유: 571,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2018-12",
    "압류.가압류": 3,
    소유: 571,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2019-01",
    "압류.가압류": 3,
    소유: 571,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2019-02",
    "압류.가압류": 5,
    소유: 569,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2019-03",
    "압류.가압류": 6,
    소유: 568,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2019-04",
    "압류.가압류": 8,
    소유: 566,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2019-05",
    "압류.가압류": 8,
    소유: 567,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2019-06",
    "압류.가압류": 8,
    소유: 567,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2019-07",
    "압류.가압류": 8,
    소유: 567,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2019-08",
    "압류.가압류": 9,
    소유: 566,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2019-09",
    "압류.가압류": 9,
    소유: 566,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2019-10",
    "압류.가압류": 9,
    소유: 566,
    신탁: 0,
    경매개시: 0,
  },
  {
    date: "2019-11",
    "압류.가압류": 14,
    소유: 561,
    신탁: 0,
    경매개시: 1,
  },
  {
    date: "2019-12",
    "압류.가압류": 17,
    소유: 558,
    신탁: 0,
    경매개시: 1,
  },
  {
    date: "2020-01",
    "압류.가압류": 26,
    소유: 549,
    신탁: 0,
    경매개시: 1,
  },
  {
    date: "2020-02",
    "압류.가압류": 30,
    소유: 549,
    신탁: 0,
    경매개시: 2,
  },
  {
    date: "2020-03",
    "압류.가압류": 37,
    소유: 458,
    신탁: 84,
    경매개시: 2,
  },
  {
    date: "2020-04",
    "압류.가압류": 38,
    소유: 457,
    신탁: 84,
    경매개시: 2,
  },
  {
    date: "2020-05",
    "압류.가압류": 38,
    소유: 457,
    신탁: 84,
    경매개시: 2,
  },
  {
    date: "2020-06",
    "압류.가압류": 40,
    소유: 455,
    신탁: 84,
    경매개시: 2,
  },
  {
    date: "2020-07",
    "압류.가압류": 171,
    소유: 318,
    신탁: 84,
    경매개시: 9,
  },
  {
    date: "2020-08",
    "압류.가압류": 173,
    소유: 315,
    신탁: 84,
    경매개시: 10,
  },
  {
    date: "2020-09",
    "압류.가압류": 179,
    소유: 300,
    신탁: 84,
    경매개시: 19,
  },
  {
    date: "2020-10",
    "압류.가압류": 184,
    소유: 295,
    신탁: 84,
    경매개시: 19,
  },
  {
    date: "2020-11",
    "압류.가압류": 188,
    소유: 290,
    신탁: 84,
    경매개시: 20,
  },
  {
    date: "2020-12",
    "압류.가압류": 193,
    소유: 283,
    신탁: 84,
    경매개시: 22,
  },
  {
    date: "2021-01",
    "압류.가압류": 203,
    소유: 273,
    신탁: 84,
    경매개시: 22,
  },
  {
    date: "2021-02",
    "압류.가압류": 400,
    소유: 74,
    신탁: 85,
    경매개시: 23,
  },
  {
    date: "2021-03",
    "압류.가압류": 402,
    소유: 72,
    신탁: 85,
    경매개시: 23,
  },
  {
    date: "2021-04",
    "압류.가압류": 406,
    소유: 68,
    신탁: 85,
    경매개시: 23,
  },
  {
    date: "2021-05",
    "압류.가압류": 406,
    소유: 68,
    신탁: 85,
    경매개시: 23,
  },
];

// 매입시점별컨텐츠
const 매입시점별컨텐츠 = [
  { date: "2012-01", cnt: 0 },
  { date: "2012-02", cnt: 1 },
  { date: "2012-03", cnt: 0 },
  { date: "2012-04", cnt: 0 },
  { date: "2012-05", cnt: 0 },
  { date: "2012-06", cnt: 0 },
  { date: "2012-07", cnt: 0 },
  { date: "2012-08", cnt: 0 },
  { date: "2012-09", cnt: 0 },
  { date: "2012-10", cnt: 0 },
  { date: "2012-11", cnt: 0 },
  { date: "2012-12", cnt: 0 },
  { date: "2013-01", cnt: 0 },
  { date: "2013-02", cnt: 0 },
  { date: "2013-03", cnt: 0 },
  { date: "2013-04", cnt: 1 },
  { date: "2013-05", cnt: 0 },
  { date: "2013-06", cnt: 0 },
  { date: "2013-07", cnt: 0 },
  { date: "2013-08", cnt: 0 },
  { date: "2013-09", cnt: 0 },
  { date: "2013-10", cnt: 0 },
  { date: "2013-11", cnt: 0 },
  { date: "2013-12", cnt: 0 },
  { date: "2014-01", cnt: 0 },
  { date: "2014-02", cnt: 0 },
  { date: "2014-03", cnt: 0 },
  { date: "2014-04", cnt: 0 },
  { date: "2014-05", cnt: 0 },
  { date: "2014-06", cnt: 0 },
  { date: "2014-07", cnt: 0 },
  { date: "2014-08", cnt: 0 },
  { date: "2014-09", cnt: 0 },
  { date: "2014-10", cnt: 0 },
  { date: "2014-11", cnt: 0 },
  { date: "2014-12", cnt: 0 },
  { date: "2015-01", cnt: 0 },
  { date: "2015-02", cnt: 0 },
  { date: "2015-03", cnt: 0 },
  { date: "2015-04", cnt: 2 },
  { date: "2015-05", cnt: 1 },
  { date: "2015-06", cnt: 0 },
  { date: "2015-07", cnt: 2 },
  { date: "2015-08", cnt: 0 },
  { date: "2015-09", cnt: 2 },
  { date: "2015-10", cnt: 5 },
  { date: "2015-11", cnt: 4 },
  { date: "2015-12", cnt: 11 },
  { date: "2016-01", cnt: 17 },
  { date: "2016-02", cnt: 10 },
  { date: "2016-03", cnt: 27 },
  { date: "2016-04", cnt: 14 },
  { date: "2016-05", cnt: 41 },
  { date: "2016-06", cnt: 45 },
  { date: "2016-07", cnt: 22 },
  { date: "2016-08", cnt: 35 },
  { date: "2016-09", cnt: 28 },
  { date: "2016-10", cnt: 36 },
  { date: "2016-11", cnt: 19 },
  { date: "2016-12", cnt: 27 },
  { date: "2017-01", cnt: 65 },
  { date: "2017-02", cnt: 24 },
  { date: "2017-03", cnt: 49 },
  { date: "2017-04", cnt: 29 },
  { date: "2017-05", cnt: 21 },
  { date: "2017-06", cnt: 19 },
  { date: "2017-07", cnt: 37 },
  { date: "2017-08", cnt: 6 },
  { date: "2017-09", cnt: 6 },
  { date: "2017-10", cnt: 3 },
  { date: "2017-11", cnt: 10 },
  { date: "2017-12", cnt: 2 },
  { date: "2018-01", cnt: 1 },
  { date: "2018-02", cnt: 2 },
  { date: "2018-03", cnt: 0 },
  { date: "2018-04", cnt: 0 },
  { date: "2018-05", cnt: 3 },
  { date: "2018-06", cnt: 1 },
  { date: "2018-07", cnt: 1 },
  { date: "2018-08", cnt: 2 },
  { date: "2018-09", cnt: 13 },
  { date: "2018-10", cnt: 0 },
  { date: "2018-11", cnt: 1 },
  { date: "2018-12", cnt: 0 },
  { date: "2019-01", cnt: 0 },
  { date: "2019-02", cnt: 0 },
  { date: "2019-03", cnt: 0 },
  { date: "2019-04", cnt: 0 },
  { date: "2019-05", cnt: 1 },
  { date: "2019-06", cnt: 0 },
  { date: "2019-07", cnt: 0 },
  { date: "2019-08", cnt: 0 },
  { date: "2019-09", cnt: 0 },
  { date: "2019-10", cnt: 0 },
  { date: "2019-11", cnt: 1 },
  { date: "2019-12", cnt: 0 },
  { date: "2020-01", cnt: 0 },
  { date: "2020-02", cnt: 5 },
  { date: "2020-03", cnt: 0 },
  { date: "2020-04", cnt: 0 },
  { date: "2020-05", cnt: 0 },
  { date: "2020-06", cnt: 0 },
  { date: "2020-07", cnt: 1 },
  { date: "2020-08", cnt: 0 },
  { date: "2020-09", cnt: 0 },
  { date: "2020-10", cnt: 0 },
  { date: "2020-11", cnt: 0 },
  { date: "2020-12", cnt: 0 },
  { date: "2021-01", cnt: 0 },
  { date: "2021-02", cnt: 0 },
  { date: "2021-03", cnt: 0 },
  { date: "2021-04", cnt: 0 },
  { date: "2021-05", cnt: 0 },
];
async function callSheet(url, sheetName) {
  const doc = new GoogleSpreadsheet(url);
  await doc.useApiKey("AIzaSyBudarQhMv3AL0900S8zFiM2HN7UaEu5_A");
  await doc.loadInfo();
  const sheet = doc.sheetsByTitle[sheetName]; // or use doc.sheetsById[id] or doc.sheetsByTitle[title]
  const rows = await sheet.getRows(); // can pass in { limit, offset }
  return rows;
}

export {
  total,
  dong,
  callSheet,
  hDate,
  상태현황전체데이터,
  매입시점전체데이터,
  매입시점별컨텐츠,
};
